import startsWith from 'lodash/startsWith';

export const pathToArr = path => (path === '/' ? ['/'] : (path.split('/').filter(it => it.length > 0)));
export const match = (pathA = '', pathB = '') => {
  const arrA = pathToArr(pathA);
  const arrB = pathToArr(pathB);

  return arrB.length > 0 && startsWith(arrA, arrB);
};
